import { useState } from 'react';

import { INITIAL_QUIZ_BANK_FILTER_STATE } from '../constants';
import { type QuizBankFilterState } from '../types';

/** 필터 상태만 든다. 파생(목록·카운트)은 서버가 한다. */
export const useQuizBankFilterState = (
  initial: Partial<QuizBankFilterState> = {},
) => {
  const [filter, changeFilter] = useState<QuizBankFilterState>({
    ...INITIAL_QUIZ_BANK_FILTER_STATE,
    ...initial,
  });

  return { filter, changeFilter };
};
